import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5de6e969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "balloon_l" }
const _hoisted_2 = { class: "face_icon" }
const _hoisted_3 = { class: "white--text" }
const _hoisted_4 = { class: "says" }
const _hoisted_5 = { class: "timestamp_l" }
const _hoisted_6 = { class: "balloon_r" }
const _hoisted_7 = { class: "face_icon" }
const _hoisted_8 = { class: "white--text" }
const _hoisted_9 = { class: "timestamp_r" }
const _hoisted_10 = { class: "says" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", null, [
      _createVNode(_component_v_card, {
        variant: "outlined",
        width: "1000px",
        class: "transcription"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Transcription")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.transcription.note), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, {
                        ref: "scrollTarget",
                        style: {"height":"450px"},
                        class: "overflow-y-auto"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcription.messages, (msg) => {
                            return (_openBlock(), _createBlock(_component_v_row, {
                              key: msg.timestamp,
                              dense: ""
                            }, {
                              default: _withCtx(() => [
                                (msg.speaker == 'Teacher')
                                  ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                          _createElementVNode("div", _hoisted_2, [
                                            _createVNode(_component_v_avatar, {
                                              color: "primary",
                                              size: "56"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_3, _toDisplayString(msg.speaker), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _createElementVNode("p", _hoisted_4, _toDisplayString(msg.text), 1),
                                          _createElementVNode("span", _hoisted_5, _toDisplayString(msg.timestamp), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_component_v_avatar, {
                                              color: "secondary",
                                              size: "56"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_8, _toDisplayString(msg.speaker), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _createElementVNode("span", _hoisted_9, _toDisplayString(msg.timestamp), 1),
                                          _createElementVNode("p", _hoisted_10, _toDisplayString(msg.text), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}